import { createAsyncActionTypes } from '../utils';

// eslint-disable-next-line import/prefer-default-export
export const GET_GAME_STATE = createAsyncActionTypes('GET_GAME_STATE');
